import { SurveyDetailBackLink } from "./survey-detail-back-link";
import { Button, LoadingIndicator } from "~/components/ui";
import { useTranslation } from "~/i18n";

interface SurveyDetailStateProps {
  error?: boolean;
  message: string;
  onRetry?: () => void;
  retrying?: boolean;
}

export function SurveyDetailState({
  error = false,
  message,
  onRetry,
  retrying = false,
}: SurveyDetailStateProps) {
  const { t } = useTranslation();
  const loading = !error;

  return (
    <div className="lg:-m-4">
      <section
        aria-busy={loading || retrying}
        className="relative flex min-h-72 items-center justify-center rounded-panel bg-surface px-6 pb-10 pt-24 shadow-raised lg:min-h-52 lg:rounded-none lg:px-[57px] lg:pb-8 lg:pt-20"
      >
        <div className="absolute left-4 top-4 lg:left-[57px] lg:top-6">
          <SurveyDetailBackLink />
        </div>

        <div className="flex max-w-xl flex-col items-center gap-3 text-center">
          {loading ? (
            <LoadingIndicator className="size-5 text-muted/70" />
          ) : null}
          <p
            role={error ? "alert" : "status"}
            className="text-sm font-medium leading-6 text-muted"
          >
            {message}
          </p>
          {onRetry ? (
            <Button
              type="button"
              onClick={onRetry}
              disabled={retrying}
              aria-busy={retrying}
              className="gap-2"
            >
              {retrying ? <LoadingIndicator /> : null}
              <span>{t("common.retry")}</span>
            </Button>
          ) : null}
        </div>
      </section>
    </div>
  );
}
